<template>
  <div class="step-section">
    <h2>Step Four: Order tests</h2>
    <p>
      Select which tests you'd like on which day for which patient.
    </p>
    <div class="date-heading-container">
      <div v-for="date in dates" class="date-heading">
        <LongDate :date="date" />
      </div>
    </div>
    <div v-for="patient in patients" class="patient-row">
      <div class="patient-heading">
        {{patient.lastName + ", " +patient.firstName +" " +patient.id + " " + patient.dateOfBirth}}
      </div>
      <div v-for="date in dates" class="patient-order">
        <span>
          <input type="checkbox" 
          @change="updateOrder($event,
          {'patient':patient,
          'test':'FBC',
          'date':date})"> FBC
        </span>
        <span>
          <input type="checkbox" 
          @change="updateOrder($event,
          {'patient':patient,
          'test':'Chem20',
          'date':date})"> Chem20
        </span>
        <span>
          <input type="checkbox"
          @change="updateOrder($event,
            {'patient':patient,
          'test':'CRP',
          'date':date})"> CRP
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import LongDate from './LongDate.vue'

export default {
  name: 'StepFour',
  components: { LongDate },
  props: ['dates', 'patients'],
  data() {
    return {}
  },
  methods: {
    updateOrder(event, params) {
      if (event.target.checked) {
        this.$emit('addOrder', params)
      } else {
        this.$emit('removeOrder', params)
      }
    }
  }
}
</script>

<style>
  .date-heading-container {
    padding-left: 120px;
    display: flex;
  }

  .date-heading {
    border: 1px solid rgb(200, 200, 200);
    padding: 4px;
    background-color: rgb(240, 240, 240);
    width: 120px;
    box-sizing: border-box;
  }

  .patient-row {
    display: flex;
  }

  .patient-heading {
    border: 1px solid rgb(200, 200, 200);
    padding: 4px;
    background-color: rgb(240, 240, 240);
    width: 112px;
  }

  .patient-order {
    width: 120px;
    border: 1px solid rgb(200, 200, 200);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>
